import httpClient from "../httpClient"

import { encodeRequestParameters } from "../request"

export function getAreaCodes(data) {
    const params = encodeRequestParameters(data)

    return httpClient
        .get("/areacode", { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}
